import { getGoogleMapsSearchUrl } from "../../../utils/common/url";

/**
 * Renders an address as a Google Maps link when the text is mappable.
 * Unmappable placeholders (empty, "No address set") stay plain text.
 *
 * @param {Object} props Component props.
 * @param {string|null|undefined} props.address Address text from a job or scope.
 * @param {string} [props.className] Extra classes for the link or fallback wrapper.
 * @param {import('react').ReactNode} [props.children] Custom content; defaults to the address text.
 * @returns {JSX.Element} Maps `<a>` or a non-link wrapper.
 */
export default function AddressMapsLink({ address, className = "", children }) {
  const mapsUrl = getGoogleMapsSearchUrl(address);
  const content = children ?? address;

  if (!mapsUrl) {
    return <span className={className}>{content}</span>;
  }

  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      title="Open in Google Maps"
      className={`cursor-pointer text-inherit no-underline hover:underline ${className}`.trim()}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      {content}
    </a>
  );
}
